import { Entity } from '@backstage/catalog-model'
import { Flex, Text } from '@backstage/ui'

const PodAdditionalInfoFields = ({ entity }: { entity: Entity }) => {
  const annotations = entity?.metadata.annotations

  const keyValues = [
    {
      key: 'Opsgenie Handler',
      value: annotations?.['sennder.com/opsgenie-handler'] || '(Not set)'
    },
    {
      key: 'MS Teams Team Name',
      value: annotations?.['sennder.com/teams-team-name'] || '(Not set)'
    },
    {
      key: 'OKTA/HR System Team Name',
      value: annotations?.['sennder.com/hr-system-team-name'] || '(Not set)'
    }
  ]

  return (
    <Flex direction="column" gap="4">
      {keyValues.map(({ key, value }) => (
        <div key={key}>
          <Text
            as="p"
            variant="body-x-small"
            color="secondary"
            style={{
              textTransform: 'uppercase',
              letterSpacing: 0.5
            }}
          >
            {key}
          </Text>
          <Text as="p" weight="bold">
            {value}
          </Text>
        </div>
      ))}
    </Flex>
  )
}

export default PodAdditionalInfoFields
